import axios from 'axios';

export const getVehicles = () => {
  return new Promise((resolve, reject) => {
    axios({
      method: 'get',
      url: 'https://us-central1-fasttrack-client.cloudfunctions.net/api/vehicles',
      headers: {
        'Content-Type': 'application/json',
      },
    })
      .then((res) => {
        resolve(res);
      })
      .catch((e) => reject(e));
  });
};
